import {
    INITIATE_PAYMENT,
    PAYMENT_CHECK_STATUS
} from "../actions/payment";

import {
    API_BASE_URL,
    API_SITE_BASE_URL,
    PAYMENT_CHECK_STATUS_URL
} from "../variables";

import axios from "axios";

const state = {};
const mutations = {};
const getters = {};
const actions = {
    [PAYMENT_CHECK_STATUS]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_SITE_BASE_URL + PAYMENT_CHECK_STATUS_URL,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    },
    [INITIATE_PAYMENT]: ({ commit, dispatch, getters }, payload) => {
        return axios({
            url: API_BASE_URL + payload.url,
            method: "POST",
            data: payload,
            headers: { 'Authorization': 'Bearer ' + getters.getUserAccessToken }
        });
    }
};


export default {
    mutations,
    actions,
    getters,
    state
};